import LogInOutButton from "src/components/login/LoginButton/LogInOutButton";
import DarkModeButton from "../components/DarkModeButton";
import { Button, IconButton, Typography } from "@mui/material";
import { KotiIcon } from "src/components/icons/NavIcons";
import { useNavigate } from "react-router-dom";

export default function SiteAppBarAnonLayout() {
  const navigate = useNavigate();

  return (
    <div style={{ display: "flex", gap: 6, alignItems: "center", justifyContent: "flex-end" }}>
      <IconButton onClick={() => navigate("/")} color="inherit">
        <KotiIcon />
      </IconButton>
      {1 == 2 && (
        <Button variant="standard" color="primaryDark" onClick={() => navigate("/hinnasto")}>
          <Typography color="primaryDark">Hinnasto</Typography>
        </Button>
      )}
      <DarkModeButton
      // color="primaryDark"
      />
      <LogInOutButton />
    </div>
  );
}
